export enum ProfileSection {
	MEDAL = 'medal',
	STATISTICS = 'statistics',
}

export interface CustomAvatars {
	categoryId: number;
	avatars: AvatarInterface[];
	categoryName: string;
	categoryTagline: string;
	isNew: boolean;
}

export interface AvatarInterface {
	avatarUrl: string;
	avatarId: number;
}

export interface DefaultAvatar {
	avatars: AvatarInterface[];
	categoryId: number;
	categoryName: string;
	categoryTagline: string;
	isNew: boolean;
}

export interface StatisticInterface {
	biggestOdd: number;
	biggestWin: number;
	totalBets: number;
	favouriteCategory: string;
	favouriteSportIcon: string;
	emptyStats: boolean;
}
export type CollapsedMarketsType = {
	prematch: { [key: number | string]: number[] | string[] };
	live: { [key: number | string]: number[] | string[] };
	popular: { [key: number | string]: number[] | string[] };
};
export interface PlayerProfileState {
	avatar: AvatarInterface[];
	playerStats: StatisticInterface[];
	medals: MedalInterface[];
	collectedMedals: PlayerMedalsInterface[];
	lastDepositMethod: string | null;
	lastDepositBankId: number | null;
	collapsedMarkets: CollapsedMarketsType;
}

export interface MedalInterface {
	id: string;
	name: string;
	shortDescription: string;
	longDescription: string;
	wonInfo: string;
	rank: string;
	bettingUrl: string;
	requiredBetCount: number;
	iconUrl: string;
	createdAt: string;
	progress: number;
	progressFraction: number;
	canBeClaimed: boolean;
	claimedAt: string | null;
}

export interface MedalDrawerContentType {
	medalDetail: 'medalDetail';
	medalGreetings: 'medalGreetings';
}

export enum MEDAL_TYPE {
	GOLD = 'GOLD',
	SILVER = 'SILVER',
	BRONZE = 'BRONZE',
}

export enum MedalTabOptions {
	ACTIVE = 'active',
	AVAILABLE = 'available',
	CLAIMED = 'claimed',
}

export interface PlayerMedalsInterface {
	[MedalTabOptions.ACTIVE]: MedalInterface[];
	[MedalTabOptions.AVAILABLE]: MedalInterface[];
	[MedalTabOptions.CLAIMED]: MedalInterface[];
	summary: {
		[MEDAL_TYPE.GOLD]: number;
		[MEDAL_TYPE.SILVER]: number;
		[MEDAL_TYPE.BRONZE]: number;
	};
}
export interface MedalInterface {
	id: string;
	name: string;
	shortDescription: string;
	longDescription: string;
	wonInfo: string;
	rank: string;
	bettingUrl: string;
	requiredBetCount: number;
	iconUrl: string;
	createdAt: string;
	progress: number;
	progressFraction: number;
	canBeClaimed: boolean;
	claimedAt: string | null;
}
